// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"overlayLoader_loaderWrapper__YUxMw"};